import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { VisitInfoModel } from 'src/formio-custom-components/src/lib/shared/model';
import { ComponentBase } from '../../base';
import { CommonQuestionModel } from '../../models';

@Component({
  selector: 'app-questions-list',
  templateUrl: './questions-list.component.html',
  styleUrls: ['./questions-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionsListComponent extends ComponentBase {
  _visitInfo: VisitInfoModel;

  questions$ = this.questionsStore.questionsStore$;

  @Output() edit = new EventEmitter<CommonQuestionModel>();
  @Output() delete = new EventEmitter<CommonQuestionModel>();
  @Output() open = new EventEmitter<CommonQuestionModel>();

  @Input() set visitInfo(val: VisitInfoModel) {
    this._visitInfo = val;
    if (val?.key) {
      this.questionsStore.initStore(val?.key);
    }
  }

  /**
   *
   */
  constructor(public injector: Injector) {
    super(injector);
  }

  trackByFn(index: number, item: CommonQuestionModel) {
    return item?.id;
  }

  editQuestion(question: CommonQuestionModel, event: Event) {
    event.stopPropagation();
    this.edit.emit(question);
  }

  deleteQuestion(question: CommonQuestionModel, event: Event) {
    event.stopPropagation();
    this.delete.emit(question);
  }

  openQuestion(question: CommonQuestionModel) {
    this.open.emit(question);
  }
}
